import { AdminList, AdminDataGrid, GridColumn } from './shared';
import { TextField, DateField, SelectInput } from 'react-admin';
import { PLAN_TIER_CHOICES } from '../constants';
import { ListActions, UserEmailField, PlanTierField } from './shared';
import { SubscriptionSourceField, SubscriptionAccessField } from './subscriptions/SubscriptionFields';

const subscriptionFilters = [
  <SelectInput key="planTier" source="planTier" label="Plan Tier" choices={PLAN_TIER_CHOICES} />,
];

export function SubscriptionList() {
  return <AdminList filters={subscriptionFilters} actions={<ListActions />}
    sort={{ field: 'createdAt', order: 'DESC' }} perPage={25}>
    <AdminDataGrid bulkActionButtons={false} rowClick={(_id, _resource, record) => `/users/${record.userId}/show`}>
      <GridColumn label="User" source="userEmail"><UserEmailField /></GridColumn>
      <GridColumn label="Plan" source="planTier"><PlanTierField label="Plan" /></GridColumn>
      <SubscriptionSourceField label="Subscription source" sortable={false} />
      <SubscriptionAccessField label="Access period" sortable={false} />
      <TextField source="status" label="Access status" sortable={false} />
      <DateField source="updatedAt" label="Updated" showTime />
    </AdminDataGrid>
  </AdminList>;
}
